var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Header } from 'telia-front-react';
import { ContactsUpdatePrompt } from '@teliaee/contacts-update-prompt';
import headerActions from './HeaderActions';
import headerEmployee from './HeaderEmployee';
import headerLanguages from './HeaderLanguages';
import headerLogo from './HeaderLogo';
import { navigate } from './HeaderNavItemEvents';
import headerSearch from './HeaderSearch';
import headerSegment from './HeaderSegment';
let HeaderContainer = class HeaderContainer extends React.Component {
    render() {
        const rootStore = this.props.rootStore;
        const { translate, translations } = rootStore.translationsStore;
        const { URLData, lang, tier, brand } = rootStore.environmentStore;
        const { section, setSection, setSectionAndPushGa } = rootStore.sectionStore;
        const { getParsedOverlayNotice } = rootStore.overlayNoticeStore;
        const { setLocation } = rootStore.locationStore;
        const { name } = rootStore.menuItemStore;
        const { navItems, setNavItems, secondaryNavItems, setSecondaryNavItems } = rootStore.navItemStore;
        const { authData } = rootStore.ssoStore;
        const { skipContactsUpdatePrompt } = rootStore.propStateStore;
        const employee = headerEmployee(rootStore);
        const languages = headerLanguages(rootStore);
        const segment = headerSegment(rootStore);
        const logo = headerLogo(rootStore);
        const actions = headerActions(rootStore);
        const search = headerSearch(rootStore);
        if (!translations) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, { employee: employee, segment: segment, search: search, languages: languages, logo: logo, nav: {
                    label: name,
                    tree: toJS(navItems),
                    onTreeChange: setNavItems,
                    secondaryTree: toJS(secondaryNavItems),
                    onSecondaryTreeChange: setSecondaryNavItems
                }, actions: actions, overlayNotice: getParsedOverlayNotice.slice(), openSection: section || '', onOpenSectionChange: setSectionAndPushGa, skipLinks: [
                    {
                        label: translate('header.main.accessibility.mainContent'),
                        url: '#main-content'
                    },
                    {
                        label: translate('header.main.accessibility.label'),
                        url: `${URLData.getPublicURL(translate('header.main.accessibility.path'))}`
                    }
                ], accessibility: {
                    url: `${URLData.getPublicURL(translate('header.main.accessibility.path'))}`,
                    label: translate('header.main.accessibility.label'),
                    onClick: (event) => navigate(event, setSection, setLocation)
                } }),
            !skipContactsUpdatePrompt && brand === 'telia' && React.createElement(ContactsUpdatePrompt, { lang: lang, tier: tier, auth: authData })));
    }
};
HeaderContainer = __decorate([
    observer
], HeaderContainer);
export default HeaderContainer;
//# sourceMappingURL=HeaderContainer.js.map